import { CarCoverageType } from '~domain/model/quote/coverage';

const keys = {
  coverage: {
    core: {
      categorizedSelect: {
        categories: {
          base: 'Base',
          extended: 'Extended',
        },
      },
    },
    car: {
      caregiver: {
        base: 'Catastrophic injuries only',
        extended: 'Catastrophic and non catastrophic injuries',
      },
      funeral: {
        base: '$25,000 to spouse, $10,000 to each dependent and up to $6,000 for funeral expenses.',
        extended: '$50,000 to spouse, $20,000 to each dependent and up to $8,000 for funeral expenses. ',
      },
      incomeReplacement: {
        base: '$ 400',
        extended: '$ {{0}}',
      },
      medicalCatastrophicInjury: {
        base: '$ 1M',
        extended: '$ 2M',
      },
      medicalNonCatastrophicInjury: {
        base: '$ 65,000',
        extended: '$ {{0}}',
      },
    },
    updateConfirmationPrompt: {
      description: {
        add: 'By adding this coverage, some extra protections will be added. It is recommended to review your protections afterwards.',
        remove:
          'By removing this coverage, others protections will be removed. It is recommended to review your protections afterwards.',
        [CarCoverageType.ThirdLiability_A]: {
          changeValue:
            'By changing the civil liability coverage for this vehicle, the civil liability coverage for all vehicles will also be updated.',
        },
      },
      actions: {
        accept: 'Ok',
        cancel: 'Cancel',
      },
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
